// Настройки Sentry фронта. Бесплатный тариф — 5 000 ошибок в месяц на всю
// организацию, и с 31.08.2026 он съеден целиком: шум вытесняет настоящие ошибки.

// Переводчик браузера и расширения переписывают DOM под React, и react-dom
// падает на своих же узлах. Не наша ошибка и не чинится нами: 54 события из
// ~390 пришедших за 30 дней (снимок devops 24.09; принято из них 14, остальное
// отрезал лимит).
const TRANSLATOR_NOISE = [
  /Failed to execute 'insertBefore' on 'Node'/,
  /Failed to execute 'removeChild' on 'Node'/,
];

// Почта пользователя попадала в события через адреса запросов: хлебные крошки
// fetch/xhr несут URL, а /quota/<почта> — один из самых частых. События уходят
// в Sentry за пределы РФ, персональным данным там не место (проверка юртекстов
// 24.09). Режем любую почту в URL и тексте крошки и в URL самого события.
const EMAIL = /[A-Za-z0-9._%+-]+(?:@|%40)[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
const scrub = (value) => (typeof value === 'string' ? value.replace(EMAIL, '[email]') : value);

export function scrubBreadcrumb(crumb) {
  if (!crumb) return crumb;
  const data = crumb.data ? { ...crumb.data, url: scrub(crumb.data.url) } : crumb.data;
  return { ...crumb, message: scrub(crumb.message), data };
}

export function scrubEvent(event) {
  if (!event) return event;
  const out = { ...event };
  if (out.request) out.request = { ...out.request, url: scrub(out.request.url) };
  // Кто — не нужно: без почты и IP событие всё равно связывается со сборкой.
  delete out.user;
  return out;
}

/** Опции Sentry.init. Выпуск — sha сборки из CI (`REACT_APP_BUILD`), иначе события не связать с кодом. */
export function sentryOptions(env = process.env) {
  return {
    dsn: env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 0.1,
    release: env.REACT_APP_BUILD || env.REACT_APP_VERSION || 'unknown',
    ignoreErrors: TRANSLATOR_NOISE,
    sendDefaultPii: false,
    beforeBreadcrumb: scrubBreadcrumb,
    beforeSend: scrubEvent,
  };
}
